import type { StorageBackendKind } from "../types";
import { idbKeyvalBackend } from "./IdbKeyvalBackend";
import { inMemoryTestBackend } from "./InMemoryTestBackend";
import { preferencesBackend } from "./PreferencesBackend";
import { secureStorageBackend } from "./SecureStorageBackend";
import type { StorageBackend } from "./StorageBackend";

/**
 * Resolves a storage backend implementation from its kind.
 *
 * @param kind Backend kind declared on a slice descriptor.
 * @returns Concrete backend instance.
 */
export const resolveBackend = ( kind: StorageBackendKind ): StorageBackend => {
    switch ( kind ) {
        case "preferences":
            return preferencesBackend;

        case "secure":
            return secureStorageBackend;

        case "idb":
            return idbKeyvalBackend;

        case "inMemoryTest":
            return inMemoryTestBackend;

        default: {
            /** Compile-time exhaustiveness guard when `StorageBackendKind` grows. */
            const exhaustiveCheck: never = kind;

            throw new Error( `Unknown storage backend kind: ${ String( exhaustiveCheck ) }` );
        }
    }
};
